<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage">
<figure class="tit" id="tit"><img alt="If the Slipper Fits by Olivia Drake" class="img90" src="images/01_Title_Page_fmt.jpeg"/></figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?274c5fe0